export default __webpack_public_path__ + "6e1826e17f3bd9a49aff9de413cf79cc.ttf";